var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaddingTopMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_249)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 14,
    width: 70,
    height: 180,
    rx: 5,
    transform: "rotate(90 188 14)",
    fill: "#007FFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 14,
    width: 70,
    height: 180,
    rx: 5,
    transform: "rotate(90 188 14)",
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3536 21.6464C92.1583 21.4512 91.8417 21.4512 91.6464 21.6464L88.4645 24.8284C88.2692 25.0237 88.2692 25.3403 88.4645 25.5355C88.6597 25.7308 88.9763 25.7308 89.1716 25.5355L92 22.7071L94.8284 25.5355C95.0237 25.7308 95.3403 25.7308 95.5355 25.5355C95.7308 25.3403 95.7308 25.0237 95.5355 24.8284L92.3536 21.6464ZM91.6464 42.3536C91.8417 42.5488 92.1583 42.5488 92.3536 42.3536L95.5355 39.1716C95.7308 38.9763 95.7308 38.6597 95.5355 38.4645C95.3403 38.2692 95.0237 38.2692 94.8284 38.4645L92 41.2929L89.1716 38.4645C88.9763 38.2692 88.6597 38.2692 88.4645 38.4645C88.2692 38.6597 88.2692 38.9763 88.4645 39.1716L91.6464 42.3536ZM91.5 22L91.5 42L92.5 42L92.5 22L91.5 22Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 50L188 79C188 81.7614 185.761 84 183 84L13 84C10.2386 84 8 81.7614 8 79L8 50L188 50Z",
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45685 80.8818C8.16357 80.3093 8 79.6718 8 79C8 79.6781 8.12271 80.3275 8.34715 80.9273L8.45685 80.8818ZM11.2531 83.2177L10.9753 83.8876C11.5914 84.2065 12.2754 84.4123 13 84.4776C13.1647 84.4924 13.3314 84.5 13.5 84.5L15.0238 84.5L15.0238 83.5L13 83.5C12.3855 83.5 11.7969 83.4002 11.2531 83.2177ZM19.0714 83.5L19.0714 84.5L23.119 84.5L23.119 83.5L19.0714 83.5ZM27.1667 83.5L27.1667 84.5L31.2143 84.5L31.2143 83.5L27.1667 83.5ZM35.2619 83.5L35.2619 84.5L39.3095 84.5L39.3095 83.5L35.2619 83.5ZM43.3571 83.5L43.3571 84.5L47.4048 84.5L47.4048 83.5L43.3571 83.5ZM51.4524 83.5L51.4524 84.5L55.5 84.5L55.5 83.5L51.4524 83.5ZM59.5476 83.5L59.5476 84.5L63.5952 84.5L63.5952 83.5L59.5476 83.5ZM67.6429 83.5L67.6429 84.5L71.6905 84.5L71.6905 83.5L67.6429 83.5ZM75.7381 83.5L75.7381 84.5L79.7857 84.5L79.7857 83.5L75.7381 83.5ZM83.8333 83.5L83.8333 84.5L87.8809 84.5L87.8809 83.5L83.8333 83.5ZM91.9286 83.5L91.9286 84.5L95.9762 84.5L95.9762 83.5L91.9286 83.5ZM100.024 83.5L100.024 84.5L104.071 84.5L104.071 83.5L100.024 83.5ZM108.119 83.5L108.119 84.5L112.167 84.5L112.167 83.5L108.119 83.5ZM116.214 83.5L116.214 84.5L120.262 84.5L120.262 83.5L116.214 83.5ZM124.31 83.5L124.31 84.5L128.357 84.5L128.357 83.5L124.31 83.5ZM132.405 83.5L132.405 84.5L136.452 84.5L136.452 83.5L132.405 83.5ZM140.5 83.5L140.5 84.5L144.548 84.5L144.548 83.5L140.5 83.5ZM148.595 83.5L148.595 84.5L152.643 84.5L152.643 83.5L148.595 83.5ZM156.691 83.5L156.691 84.5L160.738 84.5L160.738 83.5L156.691 83.5ZM164.786 83.5L164.786 84.5L168.833 84.5L168.833 83.5L164.786 83.5ZM172.881 83.5L172.881 84.5L176.929 84.5L176.929 83.5L172.881 83.5ZM180.976 83.5L180.976 84.5L182.5 84.5C182.669 84.5 182.835 84.4924 183 84.4776C183.725 84.4123 184.409 84.2065 185.025 83.8876L184.747 83.2177C184.203 83.4002 183.614 83.5 183 83.5L180.976 83.5ZM187.653 80.9273C187.877 80.3275 188 79.6781 188 79C188 79.6718 187.836 80.3093 187.543 80.8818L187.653 80.9273ZM188 50.5L188 50L188 49.5L186.043 49.5L186.043 50.5L188 50.5ZM182.13 50.5L182.13 49.5L178.217 49.5L178.217 50.5L182.13 50.5ZM174.304 50.5L174.304 49.5L170.391 49.5L170.391 50.5L174.304 50.5ZM166.478 50.5L166.478 49.5L162.565 49.5L162.565 50.5L166.478 50.5ZM158.652 50.5L158.652 49.5L154.739 49.5L154.739 50.5L158.652 50.5ZM150.826 50.5L150.826 49.5L146.913 49.5L146.913 50.5L150.826 50.5ZM143 50.5L143 49.5L139.087 49.5L139.087 50.5L143 50.5ZM135.174 50.5L135.174 49.5L131.261 49.5L131.261 50.5L135.174 50.5ZM127.348 50.5L127.348 49.5L123.435 49.5L123.435 50.5L127.348 50.5ZM119.522 50.5L119.522 49.5L115.609 49.5L115.609 50.5L119.522 50.5ZM111.696 50.5L111.696 49.5L107.783 49.5L107.783 50.5L111.696 50.5ZM103.87 50.5L103.87 49.5L99.9565 49.5L99.9565 50.5L103.87 50.5ZM96.0435 50.5L96.0435 49.5L92.1305 49.5L92.1305 50.5L96.0435 50.5ZM88.2174 50.5L88.2174 49.5L84.3044 49.5L84.3044 50.5L88.2174 50.5ZM80.3913 50.5L80.3913 49.5L76.4783 49.5L76.4783 50.5L80.3913 50.5ZM72.5653 50.5L72.5653 49.5L68.6522 49.5L68.6522 50.5L72.5653 50.5ZM64.7392 50.5L64.7392 49.5L60.8261 49.5L60.8261 50.5L64.7392 50.5ZM56.9131 50.5L56.9131 49.5L53 49.5L53 50.5L56.9131 50.5ZM49.087 50.5L49.087 49.5L45.174 49.5L45.174 50.5L49.087 50.5ZM41.2609 50.5L41.2609 49.5L37.3479 49.5L37.3479 50.5L41.2609 50.5ZM33.4348 50.5L33.4348 49.5L29.5218 49.5L29.5218 50.5L33.4348 50.5ZM25.6088 50.5L25.6088 49.5L21.6957 49.5L21.6957 50.5L25.6088 50.5ZM17.7827 50.5L17.7827 49.5L13.8696 49.5L13.8696 50.5L17.7827 50.5ZM9.9566 50.5L9.9566 49.5L8 49.5L8 50L8 50.5L9.9566 50.5Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -52,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -52,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 92,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 92,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddingTopMd);
export default __webpack_public_path__ + "static/media/padding_top_md.2b97d3eb6aa099742fa257ffc439502f.svg";
export { ForwardRef as ReactComponent };